import React from 'react';

// A compact Em chord diagram: a 6-string, 3-fret grid with a thick nut and the
// two fretted notes (A and D strings, 2nd fret). Drawn from filled rects and
// circles so it inherits the surrounding `fill` colour, matching the other
// footer icons in both themes.
const SvgEmChord = ({ style }: SvgEmChordTypes) => (
	<svg style={style} viewBox="0 0 24 24">
		{/* Nut */}
		<rect height="1.9" rx="0.4" width="18.8" x="2.6" y="3.2" />

		{/* Strings */}
		<rect height="18" width="0.7" x="2.65" y="4" />
		<rect height="18" width="0.7" x="6.25" y="4" />
		<rect height="18" width="0.7" x="9.85" y="4" />
		<rect height="18" width="0.7" x="13.45" y="4" />
		<rect height="18" width="0.7" x="17.05" y="4" />
		<rect height="18" width="0.7" x="20.65" y="4" />

		{/* Frets */}
		<rect height="0.7" width="18.4" x="3" y="9.65" />
		<rect height="0.7" width="18.4" x="3" y="15.65" />
		<rect height="0.7" width="18.4" x="3" y="21.3" />

		{/* Fretted notes: A and D strings, 2nd fret */}
		<circle cx="6.6" cy="13" r="2" />
		<circle cx="10.2" cy="13" r="2" />
	</svg>
);

type SvgEmChordTypes = {
	style?: React.CSSProperties;
};

export default SvgEmChord;
